import { Box, Typography } from "@mui/material";
import React from "react";
import { useCustomisation } from "../../context/CustomisationContext";

interface FooterLogoProps {
  poweredByText: string;
}

export const FooterLogo: React.FC<FooterLogoProps> = ({ poweredByText }) => {
  const { customisations } = useCustomisation();
  const {
    LOGIN: {
      textColorsSettings: loginTextColors,
      logoSettings: loginLogoSettings,
    },
    GPC: { textColorsSettings: gpcTextColors },
  } = customisations.customisations;
  const primaryTextColor =
    loginTextColors?.loginPrimaryTextColor ??
    gpcTextColors?.gpcPrimaryTextColor;

  const logoDark = loginLogoSettings?.loginPoweredByLogoDark;
  const logoLight = loginLogoSettings?.loginPoweredByLogoLight;
  const logoMode = loginLogoSettings?.loginPoweredByLogoMode;

  let logo = logoLight;
  if (logoMode === "dark") {
    logo = logoDark;
  } else if (logoMode === "light") {
    logo = logoLight;
  }

  return (
    <>
      {customisations.customisations.LOGIN.logoSettings?.loginPoweredBy?.toLowerCase() ===
        "true" && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "2rem",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            fontSize={14}
            color={primaryTextColor}
            marginBottom={"0.5rem"}
          >
            {poweredByText}
          </Typography>
          <img
            style={{
              height: 28,
              maxWidth: 112,
              width: "auto",
              objectFit: "contain",
              objectPosition: "center",
              display: "block",
            }}
            src={`/${logo}`}
            alt="logo"
          />
        </Box>
      )}
    </>
  );
};
